var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD3Spinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.239999C24 0.107451 23.8925 -0.000126161 23.7599 0.00119919C19.0969 0.0478267 14.5465 1.45205 10.6663 4.04473C6.71954 6.68188 3.64339 10.4302 1.82689 14.8156C0.0103866 19.201 -0.464894 24.0266 0.46115 28.6822C1.3872 33.3377 3.67298 37.6141 7.02943 40.9706C10.3859 44.327 14.6623 46.6128 19.3178 47.5388C23.9734 48.4649 28.799 47.9896 33.1844 46.1731C37.5698 44.3566 41.3181 41.2805 43.9553 37.3337C46.5479 33.4535 47.9522 28.9031 47.9988 24.2401C48.0001 24.1075 47.8925 24 47.76 24C47.6275 24 47.5201 24.1075 47.5188 24.2401C47.4722 28.8081 46.0961 33.2657 43.5562 37.067C40.9718 40.9349 37.2984 43.9495 33.0007 45.7296C28.703 47.5098 23.9739 47.9756 19.4115 47.0681C14.849 46.1605 10.6582 43.9205 7.36885 40.6311C4.07952 37.3418 1.83945 33.151 0.931929 28.5885C0.0244054 24.0261 0.49018 19.297 2.27035 14.9993C4.05053 10.7016 7.06514 7.02824 10.933 4.44383C14.7343 1.9039 19.1919 0.527833 23.7599 0.481223C23.8925 0.479871 24 0.372547 24 0.239999Z",
    fill: "url(#paint0_radial_20513_1366)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_20513_1366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(43 86)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BCFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BCFA1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD3Spinner);
export default __webpack_public_path__ + "static/media/d3-spinner.6d41a9f41401c269c500e9e584ced669.svg";
export { ForwardRef as ReactComponent };